import React, { useState } from "react";
import { FaCut, FaStore, FaFish, FaIceCream, FaBreadSlice } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "Futuro Combi", category: "Semi-Verticals", image: "images/futurocombi.png", description: "A versatile semi-vertical unit combining display and storage for maximum efficiency.", route: "/FuturoCombi-lower" },
  { name: "United", category: "Multi decks", image: "images/united.png", description: "Multi-deck solution ideal for diverse butcher shop needs and various product types.", route: "/United" },
  { name: "FUTURO 2", category: "Multi decks", image: "images/futunew.jpg", description: "The most complete and flexible solution for modern food retail.", route: "/FUTURO-22" },
  { name: "Prestige 2", category: "Display", image: "images/pristage.jpg", description: "A premium display model offering high visibility and accessibility for butcher shops.", route: "/Prestige2" },
  { name: "Daisy", category: "Semi-Verticals", image: "images/daisynew.jpg", description: "A semi-vertical solution with optimized space usage and product visibility for butcher shops.", route: "/daisy-lower" },
  { name: "Daisy", category: "Display", image: "images/daisy22.jpg", description: "A versatile and functional line with all the options for the food retail.", route: "/daisy-upper" },
  { name: "Futuro 2", category: "Semi-Verticals", image: "images/FUTURO-upper.jpg", description: "Sleek and stylish semi-vertical sushi display perfect for modern restaurants.", route: "/FUTURO2-upper" },
  { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Multi-deck model offering a space-saving solution for high-demand environments in butchery.", route: "/Futuro-2" },
  { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "Modern design for efficient product display in butcher shops and charcuteries.", route: "/Columbus-lower" },
  { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "High-quality, stylish semi-vertical model, ideal for premium butcher shops.", route: "/Victory" },
  { name: "Expo BZ", category: "Islands", image: "images/expo.png", description: "Island design with efficient product display and easy customer access, perfect for butcher shops.", route: "/EXPOBZ" },
  { name: "Futuro Island", category: "Islands", image: "images/futuruisland2.png", description: "Sleek island display designed for high-volume butcher shops and charcuteries.", route: "/FUTUROISLAND" },
  { name: "Futuro Expo", category: "Islands", image: "images/futuroexpo1.jpg", description: "Expo-style island with modern design, optimized for fresh products and customer engagement.", route: "/FUTUROEXPO" },
  { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "A convenient solution for online orders with in-store pickup for butcher shops.", route: "/CLICK&COLLECT" },

];


const icons = [
  { name: "Butcher Shop", icon: <FaCut /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
];

function ButcheryCharcuterie() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/butcherland.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Butchery & Charcuterie</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Exhibition and conservation of fresh Meat, Charcuterie and Cheese, in horizontal and vertical displays, for assisted service and self-service.
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Butchery & Charcuterie</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}

export default ButcheryCharcuterie;
// import React, { useState } from "react";
// import { FaCut, FaStore, FaFish, FaIceCream, FaBreadSlice } from "react-icons/fa";

// const models = [
//   { name: "Prestige 2", category: "Display", image: "images/pristage.jpg", description: "A premium display model offering high visibility and accessibility for butcher shops." },
//   { name: "Columbus", category: "Display", image: "images/columbus.jpg", description: "Modern design for efficient product display in butcher shops and charcuteries." },
//   { name: "Click & Collect", category: "Intelligent Solutions", image: "images/clickcollect.png", description: "A convenient solution for online orders with in-store pickup for butcher shops." },
//   { name: "Expo BZ", category: "Islands", image: "images/expo.png", description: "Island design with efficient product display and easy customer access, perfect for butcher shops." },
//   { name: "Futuro Island", category: "Islands", image: "images/futuruisland2.png", description: "Sleek island display designed for high-volume butcher shops and charcuteries." },
//   { name: "Futuro Expo", category: "Islands", image: "images/futuroexpo1.jpg", description: "Expo-style island with modern design, optimized for fresh products and customer engagement." },
//   { name: "Futuro 2", category: "Multi decks", image: "images/futuro2.jpg", description: "Multi-deck model offering a space-saving solution for high-demand environments in butchery." },
//   { name: "United", category: "Multi decks", image: "images/united.png", description: "Multi-deck solution ideal for diverse butcher shop needs and various product types." },
//   { name: "Columbus", category: "Multi decks", image: "images/columbus.jpg", description: "Multi-deck display with a focus on durability and space efficiency for butcher environments." },
//   { name: "Daisy", category: "Semi-Verticals", image: "images/daisy.png", description: "A semi-vertical solution with optimized space usage and product visibility for butcher shops." },
//   { name: "Futuro 2", category: "Semi-Verticals", image: "images/futuro2.jpg", description: "A compact semi-vertical design with advanced features, perfect for high-traffic butcher shops." },
//   { name: "Futuro Combi", category: "Semi-Verticals", image: "images/futurocombi.png", description: "A versatile semi-vertical unit combining display and storage for maximum efficiency." },
//   { name: "Daisy", category: "Semi-Verticals", image: "images/daisy2.jpg", description: "Elegant and functional semi-vertical display with exceptional organization for butcher shops." },
//   { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "High-quality, stylish semi-vertical model, ideal for premium butcher shops." },
// ];

// const icons = [
//   { name: "Butcher Shop", icon: <FaCut /> },
//   { name: "Supermarket", icon: <FaStore /> },
//   { name: "Fish & Seafood", icon: <FaFish /> },
//   { name: "Ice Cream", icon: <FaIceCream /> },
//   { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
// ];

// function ButcheryCharcuterie() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const modelsPerPage = 6;

//   // Get the current models for the current page
//   const indexOfLastModel = currentPage * modelsPerPage;
//   const indexOfFirstModel = indexOfLastModel - modelsPerPage;
//   const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

//   // Handle page change
//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

//   // Calculate total pages
//   const totalPages = Math.ceil(models.length / modelsPerPage);

//   return (
//     <div className="w-full">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-screen"
//         style={{
//           backgroundImage: "url('images/butcherland.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
//           <h1 className="text-4xl font-bold mb-4 md:text-8xl">Butchery & Charcuterie</h1>
//           <p className="text-lg max-w-2xl md:text-3xl">
//             Discover the ideal display and storage solutions for your butcher shop or charcuterie.
//           </p>
//         </div>
//       </section>

//       {/* Models Display */}
//       <section className="px-6 py-12 md:px-32">
//         <h2 className="text-4xl md:text-7xl font-bold text-center mb-10">Our Butchery & Charcuterie Models</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
//           {currentModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <div
//                 className="relative w-full h-80 mb-4"
//                 style={{
//                   backgroundImage: `url(${model.image})`,
//                   backgroundSize: "contain", // Ensures no cuts, full image shown
//                   backgroundPosition: "center",
//                   backgroundRepeat: "no-repeat",
//                   height: "300px",
//                 }}
//               ></div>
//               <h3 className="text-2xl font-semibold mb-2">{model.name}</h3>
//               <p className="text-sm opacity-80 ">{model.category}</p>
//               <p className="text-sm max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl">
//                     {icon.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Pagination */}
//         <div className="flex justify-center mt-10">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-800 text-white rounded-l"
//           >
//             Previous
//           </button>
//           <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-800 text-white rounded-r"
//           >
//             Next
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default ButcheryCharcuterie;

// import React from "react";

// const sections = [
//   {
//     title: "Islands",
//     description:
//       "Modern island displays designed for showcasing a wide variety of fresh meats and charcuterie in an open, accessible format.",
//     items: [
//       {
//         name: "Expo BZ",
//         description: "An island display for showcasing a wide variety of butchery products with style.",
//         image: "images/expo.png",
//       },
//       {
//         name: "Futuro Island",
//         description: "A modern, sleek island designed for efficient display of meats and charcuterie.",
//         image: "images/futuruisland2.png",
//       },
//       {
//         name: "Futuro Expo",
//         description: "A premium island setup that enhances the visibility of your products.",
//         image: "images/futuroexpo1.jpg",
//       },
//     ],
//   },
//   {
//     title: "Multi Decks",
//     description:
//       "Efficient and organized multi-deck solutions for large spaces, offering ample storage and visibility for your products.",
//     items: [
//       {
//         name: "Futuro 2",
//         description: "A multi-deck solution offering ample storage and seamless display for larger spaces.",
//         image: "images/futuro2.jpg",
//       },
//       {
//         name: "United",
//         description: "Organized and efficient multi-deck storage for showcasing fresh products.",
//         image: "images/united.png",
//       },
//       {
//         name: "Columbus",
//         description: "A refined multi-deck display that blends style with practicality.",
//         image: "images/columbus.jpg",
//       },
//     ],
//   },
//   {
//     title: "Semi-Verticals",
//     description:
//       "Compact and stylish semi-vertical displays, designed to maximize space utilization and product visibility.",
//     items: [
//       {
//         name: "Daisy",
//         description: "An elegant semi-vertical display designed to maximize space and style.",
//         image: "images/daisy.png",
//       },
//       {
//         name: "Futuro 2",
//         description: "A compact semi-vertical display that fits seamlessly into modern butcheries.",
//         image: "images/futuro2.jpg",
//       },
//       {
//         name: "Futuro Combi",
//         description: "A hybrid semi-vertical display for flexibility in product presentation.",
//         image: "images/futuro.jpg",
//       },
//       {
//         name: "Victory",
//         description: "A premium semi-vertical solution for superior product display.",
//         image: "images/victory.png",
//       },
//     ],
//   },
//   {
//     title: "Display",
//     description:
//       "Premium display solutions tailored for enhancing the presentation of fresh cuts and cold cuts with style and efficiency.",
//     items: [
//       {
//         name: "Prestige 2",
//         description: "A high-end display solution tailored for premium cuts and charcuterie products.",
//         image: "images/pristage.jpg",
//       },
//       {
//         name: "Columbus",
//         description: "A versatile display designed to highlight fresh meats and cold cuts.",
//         image: "images/columbus.jpg",
//       },
//     ],
//   },
// ];

// const ButcheryCharcuterie = () => {
//   return (
//     <div className="font-playfair bg-gray-50">
//       <section
//         className="relative w-full h-screen bg-cover bg-center"
//         style={{
//           backgroundImage: "url('images/butcherland.jpg')",
//         }}
//       >
//         <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center p-8 md:p-16 text-white">
//           <h1 className="text-5xl md:text-7xl font-bold text-center mb-4 leading-tight">
//             Butchery & Charcuterie Solutions
//           </h1>
//           <h2 className="text-2xl md:text-3xl font-semibold text-center max-w-2xl mx-auto mb-8">
//             Discover innovative display solutions tailored for butcheries and charcuterie needs, combining style, efficiency, and functionality.
//           </h2>
//         </div>
//       </section>

//       <div className="p-8 md:p-20 bg-gray-100">
//         <h2 className="text-3xl md:text-6xl font-bold text-center text-gray-800 mb-12">
//           Our Premium Butchery & Charcuterie<br /> Models
//         </h2>

//         {sections.map((section, index) => (
//           <div key={index} className="mb-16">
//             <h3 className="text-2xl md:text-6xl text-center font-semibold text-gray-800 mb-4">
//               {section.title}
//             </h3>
//             <p className="text-center text-lg md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto px-4 pt-3">
//               {section.description}
//             </p>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 pt-20">
//               {section.items.map((item, itemIndex) => (
//                 <div
//                   key={itemIndex}
//                   className="rounded-lg overflow-hidden shadow-lg bg-white transition-all duration-300 transform hover:scale-105"
//                 >
//                   <div
//                     className="w-full h-80 bg-cover bg-center"
//                     style={{
//                       backgroundImage: `url(${item.image})`,
//                     }}
//                   ></div>

//                   <div className="p-4">
//                     <h4 className="text-xl md:text-2xl font-semibold text-gray-800">{item.name}</h4>
//                     <p className="mt-2 text-lg text-gray-600">{item.description}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ButcheryCharcuterie;
